import { GET_PAYMENT_DEMONSTRATIVE, GET_PAYMENT_DEMONSTRATIVE_LOGS } from 'store/constants'

export function generateDocs(values) {
  return {
    type: GET_PAYMENT_DEMONSTRATIVE,
    payload: values,
  }
}

export function getReportLogs(values) {
  return {
    type: GET_PAYMENT_DEMONSTRATIVE_LOGS,
    payload: values,
  }
}